import { useState, useEffect } from 'react';
import { fetchNotifications, saveNotifications } from '../api';
import { API } from '.././config';

const glass = {
  background:           'rgba(255,255,255,0.07)',
  backdropFilter:       'blur(20px)',
  WebkitBackdropFilter: 'blur(20px)',
  border:               '1px solid rgba(255,255,255,0.12)',
  borderRadius:         16,
};

const inputStyle = {
  padding: '12px 14px', borderRadius: 12,
  border: '1px solid rgba(255,255,255,0.15)',
  background: 'rgba(255,255,255,0.07)',
  color: '#fff', width: '100%',
  boxSizing: 'border-box', fontSize: 15,
  marginBottom: 4, outline: 'none',
};

const labelStyle = {
  fontSize: 12, color: 'rgba(255,255,255,0.5)',
  marginBottom: 6, display: 'block', fontWeight: 500,
  textTransform: 'uppercase', letterSpacing: 0.5,
};

function ProSubscriptionCard({ interval, periodEnd }) {
  const [cancelling, setCancelling] = useState(false);
  const [cancelled,  setCancelled]  = useState(false);

  // Format renewal date nicely
  const renewalDate = periodEnd
    ? new Date(periodEnd).toLocaleDateString('en-CA', {
        year: 'numeric', month: 'long', day: 'numeric'
      })
    : 'Unknown';

  const intervalLabel = interval === 'year' ? 'Yearly' : 'Monthly';
  const price         = interval === 'year' ? '$19.99' : '$1.99';

  async function handleCancelRedirect() {
    // Redirect to Stripe customer portal for cancellation
    // This is the cleanest approach — Stripe handles it all
    setCancelling(true);
    try {
      const res = await fetch(`${API}/subscription/portal`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${
            localStorage.getItem('diet_tracker_token') ||
            sessionStorage.getItem('diet_tracker_token') || ''
          }`,
        },
      });
      const data = await res.json();
      if (data.url) {
        window.location.href = data.url;
      } else {
        alert('Could not open billing portal. Please try again.');
      }
    } catch (e) {
      alert('Error opening billing portal: ' + e.message);
    }
    setCancelling(false);
  }

  return (
    <div style={{ marginBottom: 16 }}>
      {/* Current plan card */}
      <div style={{
        background: 'rgba(251,191,36,0.08)',
        border: '1px solid rgba(251,191,36,0.25)',
        backdropFilter: 'blur(20px)',
        WebkitBackdropFilter: 'blur(20px)',
        borderRadius: 16, padding: 20, marginBottom: 12,
      }}>
        {/* Header */}
        <div style={{ display: 'flex', justifyContent: 'space-between',
          alignItems: 'flex-start', marginBottom: 16 }}>
          <div>
            <div style={{ display: 'flex', alignItems: 'center',
              gap: 8, marginBottom: 4 }}>
              <span style={{ fontSize: 22 }}>⭐</span>
              <span style={{ fontWeight: 800, fontSize: 18,
                color: '#fbbf24' }}>
                Pro Plan
              </span>
            </div>
            <div style={{ fontSize: 13,
              color: 'rgba(255,255,255,0.5)' }}>
              {intervalLabel} · {price} CAD
            </div>
          </div>
          <div style={{
            background: 'rgba(52,211,153,0.15)',
            border: '1px solid rgba(52,211,153,0.3)',
            borderRadius: 999, padding: '4px 12px',
            fontSize: 12, fontWeight: 700, color: '#34d399',
          }}>
            ✓ Active
          </div>
        </div>

        {/* Plan details */}
        <div style={{
          background: 'rgba(255,255,255,0.05)',
          borderRadius: 10, padding: 14, marginBottom: 16,
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between',
            marginBottom: 8 }}>
            <span style={{ fontSize: 13,
              color: 'rgba(255,255,255,0.5)' }}>
              Billing cycle
            </span>
            <span style={{ fontSize: 13, fontWeight: 600,
              color: '#fff' }}>
              {intervalLabel}
            </span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between',
            marginBottom: 8 }}>
            <span style={{ fontSize: 13,
              color: 'rgba(255,255,255,0.5)' }}>
              Amount
            </span>
            <span style={{ fontSize: 13, fontWeight: 600,
              color: '#fff' }}>
              {price} CAD / {interval === 'year' ? 'year' : 'month'}
            </span>
          </div>
          <div style={{ display: 'flex',
            justifyContent: 'space-between' }}>
            <span style={{ fontSize: 13,
              color: 'rgba(255,255,255,0.5)' }}>
              {cancelled ? 'Access until' : 'Renews on'}
            </span>
            <span style={{ fontSize: 13, fontWeight: 600,
              color: cancelled ? '#fbbf24' : '#34d399' }}>
              {renewalDate}
            </span>
          </div>
        </div>

        {/* Features included */}
        <div style={{ marginBottom: 16 }}>
          <div style={{ fontSize: 12,
            color: 'rgba(255,255,255,0.4)',
            marginBottom: 8, textTransform: 'uppercase',
            letterSpacing: 0.5 }}>
            Included in your plan
          </div>
          {[
            '🤖 Unlimited AI food lookups',
            '📷 Photo meal logging',
            '✨ Weekly AI nutrition insights',
            '🔔 Missed meal notifications',
            '📊 Advanced stats',
          ].map((f, i) => (
            <div key={i} style={{ display: 'flex',
              alignItems: 'center', gap: 8,
              padding: '5px 0', fontSize: 13,
              color: 'rgba(255,255,255,0.7)',
              borderBottom: i < 4
                ? '1px solid rgba(255,255,255,0.05)' : 'none',
            }}>
              {f}
            </div>
          ))}
        </div>

        {/* Cancel / Manage button */}
        {!cancelled && (
          <button
            onClick={handleCancelRedirect}
            disabled={cancelling}
            style={{
              width: '100%', padding: 12, borderRadius: 10,
              background: 'rgba(239,68,68,0.1)',
              border: '1px solid rgba(239,68,68,0.25)',
              color: '#fca5a5', fontSize: 14, fontWeight: 600,
              cursor: 'pointer', transition: 'all 0.2s',
            }}>
            {cancelling
              ? 'Opening billing portal...'
              : '🔧 Manage / Cancel Subscription'}
          </button>
        )}

        {cancelled && (
          <div style={{
            background: 'rgba(251,191,36,0.1)',
            border: '1px solid rgba(251,191,36,0.2)',
            borderRadius: 10, padding: 12,
            fontSize: 13, color: '#fbbf24',
            textAlign: 'center',
          }}>
            ⚠️ Subscription cancelled. Pro access continues
            until {renewalDate}.
          </div>
        )}
      </div>

      <p style={{ fontSize: 11, color: 'rgba(255,255,255,0.25)',
        textAlign: 'center', margin: 0 }}>
        Billing managed securely by Stripe ·
        Questions? Email support@diettrack.fit
      </p>
    </div>
  );
}


export default function Settings({ goals, onSave, isPro,
  interval, periodEnd, onUpgrade}) {
  const [form,         setForm]        = useState(goals);
  const [saved,        setSaved]       = useState(false);
  const [notifPrefs,   setNotifPrefs]  = useState({
    enabled: false, email: '', preferredTime: '08:00'
  });
  const [notifSaved,   setNotifSaved]  = useState(false);
  const [notifLoading, setNotifLoading] = useState(false);

  useEffect(() => { setForm(goals); }, [goals]);

  useEffect(() => {
    fetchNotifications()
      .then(setNotifPrefs)
      .catch(console.error);
  }, []);

  async function handleSaveGoals() {
    const parsed = {
      dailyCalories: parseFloat(form.dailyCalories) || 2000,
      dailyProtein:  parseFloat(form.dailyProtein)  || 150,
      dailyCarbs:    parseFloat(form.dailyCarbs)    || 200,
      dailyFat:      parseFloat(form.dailyFat)      || 65,
      dailyWaterMl:  parseFloat(form.dailyWaterMl)  || 2500,
    };
    await onSave(parsed);
    setSaved(true);
    setTimeout(() => setSaved(false), 2000);
  }

  async function handleSaveNotifications() {
    if (notifPrefs.enabled && !notifPrefs.email) {
      alert('Please enter an email address for notifications');
      return;
    }
    setNotifLoading(true);
    try {
      await saveNotifications(notifPrefs);
      setNotifSaved(true);
      setTimeout(() => setNotifSaved(false), 2000);
    } catch (e) {
      alert('Error saving notification preferences');
    }
    setNotifLoading(false);
  }

  const goalFields = [
    ['dailyCalories', '🔥 Daily Calories', 'kcal', '#ff6b6b'],
    ['dailyProtein',  '💪 Daily Protein',  'g',    '#60a5fa'],
    ['dailyCarbs',    '🌾 Daily Carbs',    'g',    '#fbbf24'],
    ['dailyFat',      '🥑 Daily Fat',      'g',    '#34d399'],
    ['dailyWaterMl',  '💧 Daily Water',    'ml',   '#93c5fd'],
  ];

  return (
    <div>
      <h2 style={{
        margin: '0 0 20px', fontSize: 22, fontWeight: 700,
        background: 'linear-gradient(135deg, #fff 0%, #a0c4ff 100%)',
        WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
      }}>
        Settings
      </h2>

      {/* ── Daily Goals ── */}
      <div style={{ ...glass, padding: 20, marginBottom: 16 }}>
        <h3 style={{ margin: '0 0 20px', fontSize: 16,
          color: 'rgba(255,255,255,0.8)' }}>
          ⚙️ Daily Goals
        </h3>
        {goalFields.map(([key, label, unit, color]) => (
          <div key={key} style={{ marginBottom: 16 }}>
            <label style={{ ...labelStyle, color }}>
              {label} ({unit})
            </label>
            <input
              type="number"
              value={form[key] || ''}
              onChange={e => setForm(f => ({ ...f, [key]: e.target.value }))}
              style={{ ...inputStyle, borderColor: `${color}44` }}
            />
          </div>
        ))}
        <button onClick={handleSaveGoals} style={{
          width: '100%', padding: 16, borderRadius: 14, border: 'none',
          background: saved
            ? 'linear-gradient(135deg, #34d399, #10b981)'
            : 'linear-gradient(135deg, #5282ff, #a855f7)',
          color: '#fff', fontSize: 16, fontWeight: 700,
          cursor: 'pointer', transition: 'all 0.3s',
          boxShadow: '0 4px 20px rgba(82,130,255,0.3)',
        }}>
          {saved ? '✅ Saved!' : '💾 Save Goals'}
        </button>
      </div>

      {/* ── Notifications ── */}
      <div style={{ ...glass, padding: 20, marginBottom: 16 }}>
        <h3 style={{ margin: '0 0 6px', fontSize: 16,
          color: 'rgba(255,255,255,0.8)' }}>
          🔔 Meal Reminders
        </h3>
        <p style={{ fontSize: 13, color: 'rgba(255,255,255,0.4)',
          margin: '0 0 20px' }}>
          Get an email if you forget to log meals for a full day
        </p>

        {/* Toggle */}
        <div style={{ display: 'flex', justifyContent: 'space-between',
          alignItems: 'center', marginBottom: 20 }}>
          <span style={{ fontSize: 15,
            color: 'rgba(255,255,255,0.8)' }}>
            Enable reminders
          </span>
          <div
            onClick={() => setNotifPrefs(p => ({
              ...p, enabled: !p.enabled
            }))}
            style={{
              width: 52, height: 28, borderRadius: 999,
              cursor: 'pointer',
              background: notifPrefs.enabled
                ? 'linear-gradient(135deg, #5282ff, #a855f7)'
                : 'rgba(255,255,255,0.15)',
              position: 'relative', transition: 'all 0.3s',
            }}>
            <div style={{
              width: 22, height: 22, borderRadius: '50%',
              background: '#fff', position: 'absolute', top: 3,
              transition: 'all 0.3s',
              left: notifPrefs.enabled ? 27 : 3,
              boxShadow: '0 2px 4px rgba(0,0,0,0.3)',
            }} />
          </div>
        </div>

        {notifPrefs.enabled && (
          <>
            <label style={labelStyle}>📧 Email address</label>
            <input
              type="email"
              placeholder="your@email.com"
              value={notifPrefs.email}
              onChange={e => setNotifPrefs(p => ({
                ...p, email: e.target.value
              }))}
              style={{ ...inputStyle, marginBottom: 16 }}
            />
            <label style={labelStyle}>⏰ Reminder time (UTC)</label>
            <input
              type="time"
              value={notifPrefs.preferredTime}
              onChange={e => setNotifPrefs(p => ({
                ...p, preferredTime: e.target.value
              }))}
              style={{ ...inputStyle, marginBottom: 16 }}
            />
            <div style={{
              fontSize: 12, color: 'rgba(255,255,255,0.3)',
              marginBottom: 16, padding: '8px 12px',
              background: 'rgba(255,255,255,0.04)',
              borderRadius: 8, lineHeight: 1.6,
            }}>
              ℹ️ Reminder sent if no meals logged previous day.
              8:00 UTC = 4:00 AM EST = 1:00 AM PST.
            </div>
          </>
        )}

        <button
          onClick={handleSaveNotifications}
          disabled={notifLoading}
          style={{
            width: '100%', padding: 16, borderRadius: 14, border: 'none',
            background: notifSaved
              ? 'linear-gradient(135deg, #34d399, #10b981)'
              : notifLoading
              ? 'rgba(255,255,255,0.1)'
              : 'linear-gradient(135deg, #f59e0b, #d97706)',
            color: '#fff', fontSize: 16, fontWeight: 700,
            cursor: 'pointer', transition: 'all 0.3s',
          }}>
          {notifSaved   ? '✅ Saved!'
            : notifLoading ? 'Saving...'
            : '🔔 Save Notification Settings'}
        </button>
      </div>

      {/* ── Subscription section ── */}

{!isPro ? (
  <div style={{
    ...glass,
    background: 'rgba(82,130,255,0.08)',
    borderColor: 'rgba(82,130,255,0.2)',
    padding: 20, marginBottom: 16,
  }}>
    <h3 style={{ margin: '0 0 8px', fontSize: 16,
      color: 'rgba(255,255,255,0.8)' }}>
      ⭐ Upgrade to Pro
    </h3>
    <p style={{ fontSize: 13, color: 'rgba(255,255,255,0.4)',
      margin: '0 0 16px', lineHeight: 1.6 }}>
      Unlimited AI lookups, photo logging, weekly AI insights,
      extended nutrients, BMI suggestions and more.
    </p>
    <button
      onClick={() => onUpgrade && onUpgrade()}
      style={{
        width: '100%', padding: 14, borderRadius: 12,
        border: 'none',
        background: 'linear-gradient(135deg, #5282ff, #a855f7)',
        color: '#fff', fontSize: 15, fontWeight: 700,
        cursor: 'pointer',
        boxShadow: '0 4px 20px rgba(82,130,255,0.3)',
      }}>
      🚀 Upgrade — from $1.99 CAD/month
    </button>
  </div>
) : (
  <ProSubscriptionCard
    interval={interval}
    periodEnd={periodEnd}
  />
)}
    </div>
  );
}